import type { CollectiveGroupSportResponse } from '@on3/api';
import { Text } from 'components/UI/Typography/Text';

import styles from './SportTab.module.scss';
import { SportTabItems } from './SportTabItems';

interface ISportTabProps {
  sports: CollectiveGroupSportResponse[] | null;
}

export const SportTab = ({ sports }: ISportTabProps) => {
  const primarySports = sports?.filter((a) => a.primary === true);
  const secondarySports = sports?.filter((a) => a.primary === false);

  return (
    <div className={styles.sportsContainer}>
      <div className={styles.sportsItemWrapper}>
        <Text className={styles.primaryTitle} variant="subtitle1">
          Primary Sport
        </Text>
        {primarySports?.map((sport) => (
          <SportTabItems key={sport.sportKey} {...sport} />
        ))}
      </div>
      <div className={styles.sportsItemWrapper}>
        <Text className={styles.nonPrimaryTitle} variant="subtitle1">
          Also Involved In
        </Text>
        {secondarySports?.map((sport) => (
          <SportTabItems key={sport.sportKey} {...sport} />
        ))}
      </div>
    </div>
  );
};
